import { render, staticRenderFns } from "./UpdateLesson.vue?vue&type=template&id=5621fb8e&"
import script from "./UpdateLesson.vue?vue&type=script&lang=js&"
export * from "./UpdateLesson.vue?vue&type=script&lang=js&"
import style0 from "./UpdateLesson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports